import React, { useMemo, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import dayjs from "dayjs";
import { fetchDataByQuery } from "../../../service/dataExport";
import { allCvReport, exportReportQuery } from "../../../static/reportQuery";

const AppTable = ({
  appicationReport,
  appicationLoading,
  teamAppicationReport,
  teamAppicationLoading,
  uniAppicationReport,
  uniAppicationLoading,
}) => {
  const rowsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesLimit, setEntriesLimit] = useState(rowsPerPage);
  const [universitySearch, setUniversitySearch] = useState("");
  const [courseSearch, setCourseSearch] = useState("");

  const hasApplData =
    appicationReport &&
    typeof appicationReport === "object" &&
    Object.keys(appicationReport).length > 0;
  const hasTeamWiseData =
    teamAppicationReport && teamAppicationReport.length > 0;
  const hasUniiseData = uniAppicationReport && uniAppicationReport.length > 0;

  const filteredData = useMemo(() => {
    if (!Array.isArray(uniAppicationReport)) return [];

    return uniAppicationReport.filter((item) => {
      const uni = item.UNIVERSITYNAME?.toLowerCase() || "";
      const course = item.COURSENAME?.toLowerCase() || "";
      const uniMatch = uni.includes(universitySearch.toLowerCase());
      const courseMatch = course.includes(courseSearch.toLowerCase());
      return uniMatch && courseMatch;
    });
  }, [uniAppicationReport, universitySearch, courseSearch]);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * entriesLimit;
    const endIndex = startIndex + entriesLimit;
    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, currentPage, entriesLimit]);

  return (
    <div className="my-3 container-fluid">
      <div className="row">
        {!appicationLoading ? (
          <div className="card mb-3 col-md-6">
            <div className="card-body">
              <div>
                <div className=" bg-transparent mb-2">
                  <span className="fs-5 fw-bold text-dark">
                    All Application Wise Reports
                  </span>
                </div>
                <div
                  className="overflow-auto wb-scrollbar-w-1 mb-3"
                  style={{ maxHeight: "50vh" }}
                >
                  {hasApplData ? (
                    <table className="table table-yesgermany table-hover table-bordered">
                      <thead>
                        <tr className="text-nowrap">
                          <th colSpan={4}>Status</th>
                          <th className="text-center">Counts</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th colSpan={4}>Total Students</th>
                          <td
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.total_students?.query,
                                allCvReport.total_students,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.total_students?.count}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>Total CL Final Students</td>
                          <td
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.cl_final_student?.query,
                                allCvReport.total_students,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.cl_final_student?.count}
                          </td>
                        </tr>
                        <tr className="text-center">
                          <th></th>
                          <th>Public</th>
                          <th>Private</th>
                          <th>Other</th>
                          <th>Total</th>
                        </tr>
                        <tr className="text-center">
                          <th className="text-start">Approved Applications</th>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport
                                  ?.total_approved_application_public?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport
                                ?.total_approved_application_public?.count
                            }
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport
                                  ?.total_approved_application_private?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport
                                ?.total_approved_application_private?.count
                            }
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport
                                  ?.total_approved_application_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport?.total_approved_application_other
                                ?.count
                            }
                          </td>
                          <td
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.total_approved_application
                                  ?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport?.total_approved_application
                                ?.count
                            }
                          </td>
                        </tr>
                        <tr>
                          <th>Applications Not Applied Yet</th>
                          <td
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.not_applied_yet_public?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.not_applied_yet_public?.count}
                          </td>
                          <td
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.not_applied_yet_private
                                  ?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.not_applied_yet_private?.count}
                          </td>
                          <td
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.not_applied_yet_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.not_applied_yet_other?.count}
                          </td>
                          <td
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.not_applied_yet_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.not_applied_yet?.count}
                          </td>
                        </tr>
                        <tr>
                          <th>Applications First Step Applied</th>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_firstStep_applied_public?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport
                                ?.application_firstStep_applied_public?.count
                            }
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_firstStep_applied_private?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport
                                ?.application_firstStep_applied_private?.count
                            }
                          </td>
                          <td 
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_firstStep_applied_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport
                                ?.application_firstStep_applied_other?.count
                            }
                          </td>
                          <td
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_firstStep_applied?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport?.application_firstStep_applied
                                ?.count
                            }
                          </td>
                        </tr>
                        <tr>
                          <th>Applications Applied</th>
                          <td 
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_applied_public?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport?.application_applied_public
                                ?.count
                            }
                          </td>
                          <td 
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_applied_private?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport?.application_applied_private
                                ?.count
                            }
                          </td>
                          <td 
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_applied_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.application_applied_other?.count}
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                          onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_applied?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                          }
                          >
                            {appicationReport?.application_applied?.count}
                          </td>
                        </tr>
                        <tr>
                          <th>Applications In Process</th>
                          <td 
                          className="text-center cursor-pointer"
                          onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_applied?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                          }
                          >
                            {
                              appicationReport?.application_in_process_public?.count
                            }
                          </td>
                          <td 
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_in_process_private?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport?.application_in_process_private
                                ?.count
                            }
                          </td>
                          <td
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_in_process_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport?.application_in_process_other
                                ?.count
                            }
                          </td>
                          <td 
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_in_process?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.application_in_process?.count}
                          </td>
                        </tr>
                        <tr>
                          <th>Applications Cancelled</th>
                          <td 
                          className="text-center cursor-pointer"
                          onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_cancelled_public?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                          }
                          >
                            {
                              appicationReport?.application_cancelled_public
                                ?.count
                            }
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                          onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_cancelled_private?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                          }
                          >
                            {
                              appicationReport?.application_cancelled_private
                                ?.count
                            }
                          </td>
                          <td
                          className="text-center cursor-pointer"
                          onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_cancelled_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                          } 
                          >
                            {
                              appicationReport?.application_cancelled_other
                                ?.count
                            }
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                          onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_cancelled?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                          } 
                          >
                            {appicationReport?.application_cancelled?.count}
                          </td>
                        </tr>
                        <tr>
                          <th>Applications Dropped By Student</th>
                          <td 
                          className="text-center cursor-pointer"
                          onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_dropped_public?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                          } 
                          >
                            {
                              appicationReport?.application_dropped_public
                                ?.count
                            }
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                          onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_dropped_private?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                          } 
                          >
                            {
                              appicationReport?.application_dropped_private
                                ?.count
                            }
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                          onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_dropped_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                          } 
                          >
                            {appicationReport?.application_dropped_other?.count}
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                          onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.application_dropped?.query,
                                `${exportReportQuery.totalStudentsReport.total}, a.publicorprivate, cm.Compname AS 'Planner status'`,
                                "Confirm to download .csv file"
                              )
                          } 
                          >
                            {appicationReport?.application_dropped?.count}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <p>No data available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="py-3">
            <SkeletonTheme highlightColor="#fff3cd">
              <Skeleton height={70} style={{ marginBottom: "10px" }} />
            </SkeletonTheme>
          </div>
        )}

        {!appicationLoading ? (
          <div className="card mb-3 col-md-6">
            <div className="card-body">
              <div>
                <div className=" bg-transparent mb-2">
                  <span className="fs-5 fw-bold text-dark">
                    Blank Status Reports
                  </span>
                </div>
                <div
                  className="overflow-auto wb-scrollbar-w-1 mb-3"
                  style={{ maxHeight: "50vh" }}
                >
                  {hasApplData ? (
                    <table className="table table-yesgermany table-hover table-bordered">
                      <thead>
                        <tr className="text-nowrap">
                          <th>Status</th>
                          <th className="text-center">Total</th>
                          <th className="text-center">Public</th>
                          <th className="text-center">Private</th>
                          <th className="text-center">Other</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>Blank Start Dates</th>
                          <td 
                            className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.blank_start_date?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.blank_start_date?.count}
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.blank_start_date_public?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.blank_start_date_public?.count}
                          </td>
                          <td 
                           className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.blank_start_date_private?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.blank_start_date_private?.count}
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.blank_start_date_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.blank_start_date_other?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>Blank First Step Deadline Dates</td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.blank_firstStep_deadline?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.blank_firstStep_deadline?.count}
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.blank_firstStep_deadline_public?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport?.blank_firstStep_deadline_public
                                ?.count
                            }
                          </td>
                          <td 
                            className="text-center cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  appicationReport?.blank_firstStep_deadline_private?.query,
                                  `${exportReportQuery.totalStudentsReport.total}`,
                                  "Confirm to download .csv file"
                                )
                              }
                          >
                            {
                              appicationReport?.blank_firstStep_deadline_private
                                ?.count
                            }
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.blank_firstStep_deadline_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {
                              appicationReport?.blank_firstStep_deadline_other
                                ?.count
                            }
                          </td>
                        </tr>
                        <tr>
                          <td>Blank Deadline Dates</td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.blank_deadline?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.blank_deadline?.count}
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.blank_deadline_public?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }>
                            {appicationReport?.blank_deadline_public?.count}
                          </td>
                          <td 
                          
                          >
                            {appicationReport?.blank_deadline_private?.count}
                          </td>
                          <td
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.blank_deadline_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.blank_deadline_other?.count}
                          </td>
                        </tr>
                        <tr>
                          <th>Deadline Missed</th>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.deadline_missed?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.deadline_missed?.count}
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.deadline_missed_public?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.deadline_missed_public?.count}
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.deadline_missed_private?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.deadline_missed_private?.count}
                          </td>
                          <td 
                          className="text-center cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                appicationReport?.deadline_missed_other?.query,
                                `${exportReportQuery.totalStudentsReport.total}`,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {appicationReport?.deadline_missed_other?.count}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <p>No data available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="py-3">
            <SkeletonTheme highlightColor="#fff3cd">
              <Skeleton height={70} style={{ marginBottom: "10px" }} />
            </SkeletonTheme>
          </div>
        )}
      </div>

      {!teamAppicationLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="header mb-2">
                <span className="fs-5 fw-bold text-dark">
                  Application Report Team-wise
                </span>
              </div>
              <div className="overflow-auto wb-scrollbar-w-1">
                {hasTeamWiseData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="table-secondary">
                      <tr className="text-nowrap">
                        <th>Team Member</th>
                        <th className="text-center">Total Students</th>
                        <th className="text-center">CL Final Students</th>
                        <th className="text-center">Total Applications</th>
                        <th className="text-center">Approved Applications</th>
                        <th className="text-center">- Blank Open Dates</th>
                        <th className="text-center">- Blank Deadline Dates</th>
                        <th className="text-center">Not Applied Yet</th>
                        <th className="text-center">- Deadline Missed</th>
                        <th className="text-center">Application Approved</th>
                        <th className="text-center">Application In-Process</th>
                      </tr>
                    </thead>
                    <tbody>
                      {teamAppicationReport?.map(({ name, details }, idx) => (
                        <tr key={idx} className="text-center">
                          <td className="text-start">{name}</td>
                          <td className="text-center">
                            {details?.total_students?.count}
                          </td>
                          <td className="text-center">
                            {details?.cl_final_student?.count}
                          </td>
                          <td className="text-center">
                            {details?.total_application?.count}
                          </td>
                          <td className="text-center">
                            {details?.total_approved_application?.count}
                          </td>
                          <td className="text-center">
                            {details?.blank_start_date?.count}
                          </td>
                          <td className="text-center">
                            {details?.blank_deadline?.count}
                          </td>
                          <td className="text-center">
                            {details?.not_applied_yet?.count}
                          </td>
                          <td className="text-center">
                            {details?.deadline_missed?.count}
                          </td>
                          <td className="text-center">
                            {details?.total_approved_application?.count}
                          </td>
                          <td className="text-center">
                            {details?.application_in_process?.count}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SkeletonTheme highlightColor="#fff3cd">
          <Skeleton height={70} style={{ marginBottom: "10px" }} />
        </SkeletonTheme>
      )}

      {!uniAppicationLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="header mb-2">
                <span className="fs-5 fw-bold text-dark">
                  Universities Application Report
                </span>
                <div className="row bg-light">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search University"
                      value={universitySearch}
                      onChange={(e) => {
                        setUniversitySearch(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search Course"
                      value={courseSearch}
                      onChange={(e) => {
                        setCourseSearch(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                className="overflow-auto wb-scrollbar-w-1 mb-3"
                style={{ maxHeight: "50vh" }}
              >
                {hasUniiseData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="table-secondary sticky-top">
                      <tr className="text-nowrap">
                        <th>University</th>
                        <th>Course</th>
                        <th>Application Approved</th>
                        <th>Blank Open Dates</th>
                        <th>Open Dates</th>
                        <th>First Step Deadline Date</th>
                        <th>Blank First Step Deadline Date</th>
                        <th>Deadline Dates</th>
                        <th>Blank Deadline Dates</th>
                        <th>Deadline Missed</th>
                        <th>Not Applied Yet</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData?.map((item, idx) => (
                        <tr key={idx} className="text-center">
                          <td className="text-start">{item?.UNIVERSITYNAME}</td>
                          <td className="text-start">{item?.COURSENAME}</td>
                          <td className="text-start">{item?.APPROVED}</td>
                          <td className="text-start">{item?.BLANKOPENDATE}</td>
                          <td className="text-start">
                            {dayjs(item?.APPLICATIONSTARTDATENEW).format(
                              "DD MMM YYYY"
                            )}
                          </td>
                          <td className="text-start">
                            {item?.FIRSTSTEPDEADLINEDATENEW != null
                              ? dayjs(item?.FIRSTSTEPDEADLINEDATENEW).format(
                                  "DD MMM YYYY"
                                )
                              : ""}
                          </td>
                          <td className="text-start">
                            {item?.BLANKFIRSTDEADLINEDATE}
                          </td>
                          <td className="text-start">
                            {item?.DEADLINE != null
                              ? dayjs(item?.DEADLINE).format("DD MMM YYYY")
                              : ""}
                          </td>
                          <td className="text-start">
                            {item?.BLANKDEADLINEDATE}
                          </td>
                          <td className="text-start">{item?.DEADLINEMISSED}</td>
                          <td className="text-start">{item?.NOTAPPLIED}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SkeletonTheme highlightColor="#fff3cd">
          <Skeleton height={70} style={{ marginBottom: "10px" }} />
        </SkeletonTheme>
      )}
    </div>
  );
};

export default AppTable;
